import { render, staticRenderFns } from "./FormDefinitionJsonForm.vue?vue&type=template&id=a34cc1ee"
import script from "./FormDefinitionJsonForm.vue?vue&type=script&lang=js"
export * from "./FormDefinitionJsonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a34cc1ee')) {
      api.createRecord('a34cc1ee', component.options)
    } else {
      api.reload('a34cc1ee', component.options)
    }
    module.hot.accept("./FormDefinitionJsonForm.vue?vue&type=template&id=a34cc1ee", function () {
      api.rerender('a34cc1ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/form/FormDefinitionJsonForm.vue"
export default component.exports